(function () {
/* eslint-disable max-len, no-param-reassign, no-unused-vars */ /**
 * Air theme JavaScript.
 */ // Import modules
/* eslint-disable no-param-reassign */ function $72f32b121603cc1b$export$2e2bcd8739ae039(stringKey) {
    if (typeof window.dominion_screenReaderText === 'undefined' || typeof window.dominion_screenReaderText[stringKey] === 'undefined') {
        // eslint-disable-next-line no-console
        console.error(`Missing translation for ${stringKey}`);
        return '';
    }
    return window.dominion_screenReaderText[stringKey];
}


function $be72fc40c39eb295$var$isLinkExternal(link, localDomains) {
    // Empty links are not external
    if (!link.length) return false;
    const exceptions = [
        '#',
        'tel:',
        'mailto:',
        '/'
    ];
    // Check if the url starts with some of the exceptions
    const isException = exceptions.some((exception)=>{
        const compare = new RegExp(`^${exception}`, 'g');
        return compare.test(link);
    });
    if (isException) return false;
    let linkUrl;
    try {
        linkUrl = new URL(link);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(`Invalid URL: ${link}`);
        return false;
    }
    // Check if host is one of the local domains
    return !localDomains.some((domain)=>linkUrl.host === domain);
}
function $be72fc40c39eb295$export$967d794570dbbeff(link) {
    const children = [
        ...link.children
    ];
    if (children.length === 0) return '';
    const childImgs = children.filter((child)=>child.tagName.toLowerCase() === 'img');
    // If there are other elements than img elements, no need to add aria-label
    if (children.length !== childImgs.length) return '';
    // Find alt texts and add to array
    const altTexts = childImgs.filter((child)=>child.alt && child.alt !== '').map((child)=>child.alt);
    // If there is no alt texts,
    if (!altTexts.length) return '';
    return altTexts.join(', ');
}
function $be72fc40c39eb295$export$554fdaa2aa89d7a4() {
    let localDomains = [
        window.location.host
    ];
    if (typeof window.dominion_externalLinkDomains !== 'undefined') localDomains = localDomains.concat(window.dominion_externalLinkDomains);
    const links = document.querySelectorAll('a');
    const externalLinks = [
        ...links
    ].filter((link)=>$be72fc40c39eb295$var$isLinkExternal(link.href, localDomains));
    // eslint-disable-next-line consistent-return
    externalLinks.forEach((externalLink)=>{
        // Abort mission if there is only img element inside of link
        if (externalLink.childElementCount === 1 && externalLink.children[0].tagName.toLowerCase() === 'img') return false;
        if (!externalLink.classList.contains('no-external-link-label')) {
            // innerText keeps the word break of a <br> (e.g. a street address), so the label matches the visible text
            const linkText = externalLink.innerText.replace(/\s+/g, ' ').trim();
            const textContent = linkText.length ? linkText : $be72fc40c39eb295$export$967d794570dbbeff(externalLink);
            if (textContent && !externalLink.getAttribute('aria-label')) {
                const ariaLabel = externalLink.target === '_blank' ? `${textContent}: ${(0, $72f32b121603cc1b$export$2e2bcd8739ae039)('external_link')}, ${(0, $72f32b121603cc1b$export$2e2bcd8739ae039)('target_blank')}` : `${textContent}: ${(0, $72f32b121603cc1b$export$2e2bcd8739ae039)('external_link')}`;
                externalLink.setAttribute('aria-label', ariaLabel);
            }
        }
        // Arrow icon won't be added if one of these classes is defined for the link
        const classExceptions = [
            'no-external-link-indicator',
            'global-link',
            'button'
        ];
        if (!classExceptions.some((className)=>externalLink.classList.contains(className))) {
            // Add SVG arrow icon
            externalLink.insertAdjacentHTML('beforeend', '<svg class="external-link-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 9 9"><path d="M4.499 1.497h4v4m0-4l-7 7" fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
            externalLink.classList.add('is-external-link');
        }
    });
}
function $be72fc40c39eb295$export$636763119f974537() {
    // Add aria-labels to links without text or aria-labels and contain image with alt text
    const links = [
        ...document.querySelectorAll('a')
    ];
    // eslint-disable-next-line no-unused-vars
    const linksWithImgChildren = links.forEach((link)=>{
        // If link already has text content or an aria label no need to add aria-label
        if (link.textContent.trim() !== '' || link.ariaLabel) return;
        const ariaLabel = $be72fc40c39eb295$export$967d794570dbbeff(link);
        if (ariaLabel !== '') link.ariaLabel = ariaLabel;
    });
}


/* eslint-disable no-param-reassign, no-undef */ const $b4666473b658c810$var$initAnchors = ()=>{
    let triggers = document.querySelectorAll('a[href*="#"]:not([href="#"]):not(#top)');
    triggers = Array.from(triggers);
    triggers.forEach((trigger)=>{
        const targetId = trigger.hash.substring(1);
        const target = document.getElementById(targetId);
        trigger.addEventListener('click', (event)=>{
            event.preventDefault(); // Prevent default behavior of anchor links
            // If the trigger is nav-link, close nav
            if (trigger.classList.contains('nav-link') || trigger.classList.contains('dropdown-item')) {
                document.body.classList.remove('js-nav-active');
                // Additional navigation cleanup
                const html = document.documentElement;
                const container = document.getElementById('main-navigation-wrapper');
                const menu = container?.querySelector('ul');
                const button = document.getElementById('nav-toggle');
                if (html) html.classList.remove('disable-scroll');
                if (container) container.classList.remove('is-active');
                if (button) {
                    button.classList.remove('is-active');
                    button.setAttribute('aria-expanded', 'false');
                }
                if (menu) menu.setAttribute('aria-expanded', 'false');
            }
            // Check if the target element exists on the current page
            if (target) {
                // Scroll to the target element
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                // Update URL history
                window.history.pushState('', '', trigger.hash);
                // Focus on the target element
                target.setAttribute('tabindex', '-1');
                target.focus({
                    preventScroll: true
                });
            } else // Navigate to the target page
            window.location.href = trigger.href;
        });
    });
};
var $b4666473b658c810$export$2e2bcd8739ae039 = $b4666473b658c810$var$initAnchors;


const $244ddd85eab3a286$var$initA11ySkipLink = ()=>{
    // Go through all the headings of the page and select the first one
    const a11ySkipLinkTarget = document.querySelectorAll('h1, h2, h3, h4, h5, h6')[0];
    const a11ySkipLink = document.querySelectorAll('.skip-link')[0];
    // When clicked, move focus to the target element
    if (a11ySkipLink) a11ySkipLink.addEventListener('click', ()=>{
        a11ySkipLinkTarget.setAttribute('tabindex', '-1');
        a11ySkipLinkTarget.focus();
        a11ySkipLinkTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
};
var $244ddd85eab3a286$export$2e2bcd8739ae039 = $244ddd85eab3a286$var$initA11ySkipLink;


const $4e71423afcfa2c83$var$initA11yFocusSearchField = ()=>{
    const urlSearch = window.location.search;
    const urlParams = new URLSearchParams(urlSearch);
    if (urlParams.has('s')) {
        const searchField = document.querySelector('main input[name="s"]');
        if (searchField) searchField.focus({
            preventScroll: true
        });
    }
};
var $4e71423afcfa2c83$export$2e2bcd8739ae039 = $4e71423afcfa2c83$var$initA11yFocusSearchField;


/**
 * Dominion navigation: native button activation, hover and keyboard disclosure.
 * Keeps Air-light's walker markup and CSS state classes.
 */ function $d2563fe93513be8c$var$initNavigation() {
    const nav = document.querySelector('.nav-primary');
    const toggle = document.getElementById('nav-toggle');
    const wrapper = document.getElementById('menu-items-wrapper');
    if (!nav || !toggle || !wrapper) return;
    const breakpoint = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-nav').trim();
    const mobile = window.matchMedia(`(max-width: ${breakpoint})`);
    const labels = window.dominion_screenReaderText;
    const buttons = [
        ...nav.querySelectorAll('.dropdown-toggle')
    ];
    function setSubmenu(button, open) {
        button.setAttribute('aria-expanded', String(open));
        const link = button.parentElement.querySelector('a');
        button.setAttribute('aria-label', `${open ? labels.collapse_for : labels.expand_for} ${link.textContent.trim()}`);
        button.classList.toggle('toggled-on', open);
        button.parentElement.classList.toggle('hover-intent', open);
        button.nextElementSibling.classList.toggle('toggled-on', open);
        if (!open) button.nextElementSibling.querySelectorAll('.dropdown-toggle').forEach((child)=>setSubmenu(child, false));
    }
    function closeSubmenus() {
        buttons.forEach((button)=>setSubmenu(button, false));
    }
    function positionPanel() {
        if (mobile.matches) {
            const bottom = document.querySelector('.site-header').getBoundingClientRect().bottom;
            wrapper.style.top = `${bottom}px`;
            wrapper.style.height = `calc(100dvh - ${bottom}px)`;
        } else {
            wrapper.style.top = '';
            wrapper.style.height = '';
        }
    }
    function setMobile(open, restoreFocus = false) {
        document.body.classList.toggle('js-nav-active', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? labels.collapse_toggle : labels.expand_toggle);
        wrapper.inert = mobile.matches && !open;
        if (open) {
            window.scrollTo(0, 0);
            positionPanel();
        } else {
            closeSubmenus();
            if (restoreFocus) toggle.focus();
        }
    }
    buttons.forEach((button, index)=>{
        const submenu = button.nextElementSibling;
        submenu.id = `navigation-submenu-${index}`;
        button.setAttribute('aria-controls', submenu.id);
        setSubmenu(button, false);
        // Buttons emit one click for mouse, Enter and Space.
        button.addEventListener('click', ()=>{
            setSubmenu(button, button.getAttribute('aria-expanded') !== 'true');
        });
        button.parentElement.addEventListener('pointerenter', (event)=>{
            if (!mobile.matches && event.pointerType === 'mouse') setSubmenu(button, true);
        });
        button.parentElement.addEventListener('pointerleave', ()=>{
            if (!mobile.matches && !button.parentElement.contains(document.activeElement)) setSubmenu(button, false);
        });
        button.parentElement.addEventListener('focusout', ()=>{
            window.setTimeout(()=>{
                if (!button.parentElement.contains(document.activeElement)) setSubmenu(button, false);
            }, 0);
        });
    });
    toggle.addEventListener('click', ()=>setMobile(toggle.getAttribute('aria-expanded') !== 'true'));
    nav.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') {
            const item = event.target.closest('.menu-item-has-children');
            const button = item?.querySelector(':scope > .dropdown-toggle');
            if (button?.getAttribute('aria-expanded') === 'true') {
                setSubmenu(button, false);
                button.focus();
            } else if (mobile.matches && toggle.getAttribute('aria-expanded') === 'true') setMobile(false, true);
            event.preventDefault();
        }
        if (event.key === 'ArrowDown' && event.target.classList.contains('dropdown-toggle')) {
            setSubmenu(event.target, true);
            event.target.nextElementSibling.querySelector('a').focus();
            event.preventDefault();
        }
        if (event.key === 'Tab' && mobile.matches && toggle.getAttribute('aria-expanded') === 'true') {
            const focusable = [
                ...nav.querySelectorAll('a, button')
            ].filter((element)=>element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && event.target === first) {
                last.focus();
                event.preventDefault();
            } else if (!event.shiftKey && event.target === last) {
                first.focus();
                event.preventDefault();
            }
        }
    });
    document.addEventListener('click', (event)=>{
        if (!nav.contains(event.target) && !mobile.matches) closeSubmenus();
    });
    mobile.addEventListener('change', ()=>{
        const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
        setMobile(false);
        positionPanel();
        if (wasOpen) {
            if (mobile.matches) toggle.focus();
            else nav.querySelector('a').focus();
        }
    });
    window.addEventListener('resize', positionPanel);
    setMobile(false);
    positionPanel();
}
var $d2563fe93513be8c$export$2e2bcd8739ae039 = $d2563fe93513be8c$var$initNavigation;


// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $b4666473b658c810$export$2e2bcd8739ae039)();
    (0, $be72fc40c39eb295$export$554fdaa2aa89d7a4)();
    (0, $be72fc40c39eb295$export$636763119f974537)();
    (0, $244ddd85eab3a286$export$2e2bcd8739ae039)();
    (0, $4e71423afcfa2c83$export$2e2bcd8739ae039)();
    (0, $d2563fe93513be8c$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=front-end.js.map
